interface BackupRequestDTOProps {
  remittanceItemId: number;
  claimNumber: string;
  disputeTypeId: number;
  disputeSubTypeId?: number;
  note: string;
  contactInfo?: { name: string; email: string };
  isCustomerDeduction?: boolean;
}

interface IBackupRequestLookupsDTO {
  purchaserKey: string;
}

export type { BackupRequestDTOProps, IBackupRequestLookupsDTO };

export class BackupRequestLookupsDTO {
  readonly purchaserKey: string;
  constructor(data: IBackupRequestLookupsDTO) {
    this.purchaserKey = data.purchaserKey;
  }
}

export class BackupRequestDTO {
  readonly remittanceItemId: number;
  readonly claimNumber: string;
  readonly disputeTypeId: number;
  readonly disputeSubTypeId?: number;
  readonly note: string;
  readonly contactInfo?: { name: string; email: string };
  readonly isCustomerDeduction?: boolean;
  constructor(data: BackupRequestDTOProps) {
    this.remittanceItemId = data.remittanceItemId;
    this.claimNumber = data.claimNumber;
    this.disputeTypeId = data.disputeTypeId;
    this.disputeSubTypeId = data.disputeSubTypeId;
    this.note = data.note;
    this.contactInfo = data.contactInfo;
    this.isCustomerDeduction = data.isCustomerDeduction;
  }
}
